// Klasser för komponenten <eui-dialog> och anslutande:

// Gemensam för alla sådana här klasser på en sida, vilket är precis det vi vill:
//let uniktIdCounter = 0;


//###################################################################################################
// Typer av "dialogknappar":

// En metod att få "enum" i JavaScript:
const knappTypEnum = Object.freeze({
	AVBRYT: 0,
	EVENT: 1,
	// Utgått: SUBMIT_FORM:	2,
});


//###################################################################################################
// "Private" hjälpklass för knappTypEnum

const knappTypHelpers = {
	_godkandaTyperEnumvarden: [
		knappTypEnum.AVBRYT,
		knappTypEnum.EVENT,
		// Utgått: knappTypEnum.SUBMIT_FORM,
	],

	arGodkandTyp(typEnumvarde)
	{
		return this._godkandaTyperEnumvarden.indexOf(typEnumvarde) !== -1;
	},
}


//###################################################################################################
// En enskild dialog:

class dialogConfigClass
{
	constructor(knappar,
		// Named and optional parameters (med eventuella default satta), as options object:
		{
			visas = false,
		}
			= {}	// Default för den optional options-parametern som sådan.
	)
	{
		// Först lite basic typkontroller av parametrarna: ---------------------------

		// Alt: Array.isArray(knappar)
		console.assert(knappar instanceof Array,
			'Parametern \'knappar\' är obligatorisk och måste vara av typen \'Array\'.'
		);

		console.assert(knappar.every(val => val instanceof _knappBase),
			'Alla värden i arrayen \'knappar\' måste vara av typen \'_knappBase\'.'
		);

		// ---------------------------------------------------------------------------

		// Todo: Denna borde ev *inte* ligga inom config-classen. Den fungerar bara som en dum variabel, som sedan ändå måste skickas med till dialog-komponenten (via propen vpVisaDialogen) om den ska få någon innebörd för visningslogiken. I något fall (ssoChartWidget.vue) används den helt enkelt inte utan en helt annan variabel styr visningen. Då är den väldigt förvillande!
		// Om det ska ändras så sök på ".visas = " så hittas lätt de ställen där variabeln ska brytas ut utanför config-objektet.
		this.visas = visas;

		this.knappar = knappar;

		// Ersatt ovan:
		//// Knapparna adderas medelst iteration, för att typechecka dem en och en:
		//// Just typechecken hade annars
		//// Om att iterera arrayer (med for-of i detta fall):
		//// https://stackoverflow.com/questions/9329446/for-each-over-an-array-in-javascript
		//for (var knapp of knappar){
		//	// Todo: Denna typecheck var utkommenterad. Minns inte varför, så jag lägger till igen:
		//	if (!(knapp instanceof _knappBase))
		//	{
		//		const feltext = `Knappen '${knapp}' är inte en instans av klassen '_knappBase'.`;
		//		throw new TypeError(feltext);
		//	}
		//	this.knappar.push(knapp);
		//}

		// Kolla att varje del med eventId har ett unikt sådant:
		// Todo: Detta ska ändras så att unikiteten är per eventId + eventData. Fixat snabbt med en '+' av värdena nedan:

		// SO: https://stackoverflow.com/a/30735595/593779
		// "Here, we insert each and every object's name into the Set and we check if the size before and after adding are the same. This works because Set.size returns a number based on unique data (set only adds entries if the data is unique). If/when you have duplicate names, the size won't increase (because the data won't be unique) which means that we would have already seen the current name and it will return true."

		let seen = new Set();

		// The some() method tests whether at least one element in the array passes the test implemented by the provided function:
		let hasDuplicates = this.knappar.filter((item) => { return item.eventId !== undefined; })
			.some((currentObject) =>
			{
				return seen.size === seen.add(currentObject.eventId + JSON.stringify(currentObject.eventData)).size;
			}
			);

		console.assert(!hasDuplicates,
			'Det finns minst en knapp som har ett icke-unikt event-id (i kombination med event-data).',
			this.knappar
		);
	}

	get antalKnappar()
	{
		return this.knappar.length;
	}

	get standardknappIndex()
	{
		// F.n. anses den sista knappen vara standardknappen:
		return this.antalKnappar - 1;
	}
}

//###################################################################################################
// En enskild dialog-knapp, av godtycklig typ ("Private" "basklass"):

class _knappBase
{
	constructor(typ,
		// Named and optional parameters (med eventuella default satta), as options object:
		{
			text,			// undefined => ingen text.
			ikon,			// undefined => ingen ikon.
			eventId,
			eventData,
			validateBeforeEmit,
			//lank,
			cssModifierClass,
			//komponentnamn,
		}
			= {}	// Default för den optional options-parametern som sådan.
	)
	{
		console.assert(knappTypHelpers.arGodkandTyp(typ),
			`Det finns ingen knapptyp med enum-värdet '${typ}'.`
		);

		this.typ = typ;
		this.text = text;
		this.ikon = ikon;
		this.eventId = eventId;
		this.eventData = eventData;
		this.validateBeforeEmit = validateBeforeEmit;
		this.cssModifierClass = cssModifierClass;
	}

	get arAvTypAvbryt()
	{
		return this.typ === knappTypEnum.AVBRYT;
	}

	get arAvTypEvent()
	{
		return this.typ === knappTypEnum.EVENT;
	}

	// Utgått: 
	//get arAvTypSubmitForm() {
	//	return this.typ === knappTypEnum.SUBMIT_FORM;
	//}

	//get arValbar() {
	//	return this.typ === knappTypEnum.ALTERNATIV;
	//}

}

//###################################################################################################
// En Avbryt-knapp:

class knappAvbrytClass extends _knappBase
{
	constructor(
		// Named and optional parameters (med eventuella default satta), as options object:
		{
			text = 'Avbryt',
			//eventId = 'avbrytMeddelandedialog',
			cssModifierClass = '-lank',
		}
			= {}	// Default för den optional options-parametern som sådan.
	)
	{
		super(knappTypEnum.AVBRYT, {
			text: text,
			//eventId: eventId,
			cssModifierClass: cssModifierClass,
		});
	}
}

//###################################################################################################
// En Event-knapp (normal knapp):

class knappEventClass extends _knappBase
{
	constructor(text, eventId,
		// Named and optional parameters (med eventuella default satta), as options object:
		{
			ikon,
			eventData,
			validateBeforeEmit = false,
			cssModifierClass = '-primar',
		}
			= {}	// Default för den optional options-parametern som sådan.
	)
	{
		super(knappTypEnum.EVENT, {
			text: text,
			ikon: ikon,
			eventId: eventId,
			eventData: eventData,
			validateBeforeEmit: validateBeforeEmit,
			cssModifierClass: cssModifierClass,
		});
	}
}

// Utgått: 
////###################################################################################################
//// En Submit form-knapp (normal knapp):

//class knappSubmitFormClass extends _knappBase
//{
//	constructor(text, eventId,
//		// Named and optional parameters (med eventuella default satta), as options object:
//		{
//			ikon,
//			// eventData,		..sätts för denna knapptyp alltid till FormData() för den *enda* <form ..> som får finnas i dialogen.
//			cssModifierClass = '-primar',
//		}
//		= {}	// Default för den optional options-parametern som sådan.
//	)
//	{
//		super(knappTypEnum.SUBMIT_FORM, {
//			text: text,
//			ikon: ikon,
//			eventId: eventId,
//			cssModifierClass: cssModifierClass,
//		});
//	}
//}


export default {
	knappTypEnum: knappTypEnum,
	dialogConfig: dialogConfigClass,
	knappAvbryt: knappAvbrytClass,
	knappEvent: knappEventClass,
	// Utgått: knappSubmitForm: knappSubmitFormClass,
}

